import React from 'react';
import { Hero } from './components/landing/Hero';
import { SocialProof } from './components/landing/SocialProof';
import { PainPoints } from './components/landing/PainPoints';
import { TargetAudience } from './components/landing/TargetAudience';
import { ProductOverview } from './components/landing/ProductOverview';
import { ContentDetails } from './components/landing/ContentDetails';
import { Bonuses } from './components/landing/Bonuses';
import { Comparison } from './components/landing/Comparison';
import { Pricing } from './components/landing/Pricing';
import { MegapackDetails } from './components/landing/MegapackDetails';
import { Guarantee } from './components/landing/Guarantee';
import { FAQ } from './components/landing/FAQ';
import { FinalCTA } from './components/landing/FinalCTA';
import { Footer } from './components/landing/Footer';
import { PurchasePopup } from './components/landing/PurchasePopup';
import { MetaPixel } from './components/analytics/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-teal-200 selection:text-teal-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <PainPoints data-id="element-5" />
        <TargetAudience data-id="element-6" />
        <ProductOverview data-id="element-7" />
        <ContentDetails data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Comparison data-id="element-10" />
        <Pricing data-id="element-11" />
        <MegapackDetails data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <PurchasePopup data-id="element-17" />
    </div>;
}